import React from "react"
import PropTypes from "prop-types"

import oneHour from "@irati/ui/images/delivery_1hr.svg"
import instant from "@irati/ui/images/delivery_instant.svg"
import noDelivery from "@irati/ui/images/delivery_long.svg"
import styled from "styled-components"

const Image = styled.img`
  width: 30px;
`
const DeliveryHighlight = ({type, ...props}) => {
  let image = noDelivery
  switch (type) {
    case "1h":
      image = oneHour
      break
    case "instant":
      image = instant
      break
    default:
      image = noDelivery
  }
  return <Image src={image} {...props} alt="delivery type" />
}

DeliveryHighlight.propTypes = {
  type: PropTypes.oneOf(["1h", "instant", null])
}
DeliveryHighlight.defaultProps = {
  type: null
}

export default DeliveryHighlight
